// Modules
import React from 'react'
import { useLocation } from 'react-router-dom'
// Application
import { getQueryParamsValue } from 'utils'
import { ScheduleRedirect, PartnerRedirect } from 'components'

export const RedirectPage: React.VFC = () => {
    const location = useLocation()
    const redirectType = getQueryParamsValue(location, 'type')

    if (redirectType === 'telemed') {
        return <PartnerRedirect />
    }
    return <ScheduleRedirect />
}
